import React, { Component } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import Auth from "./containers/auth/Auth";
import Public from "./containers/public/Public";
import Coc from "./containers/public/coc";
import Application from "./containers/application/Application";

import "./Main.css"

let Main = class Main extends Component {
  render() {
    //console.log(this.props.auth.isLoggedIn);
    const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={ props =>
          this.props.auth.isLoggedIn ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/auth/login",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );

    const PublicRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={ props =>
          !this.props.auth.isLoggedIn ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/application",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );

    return (
      <Switch>
        <Route path="/code-of-conduct" component={Coc} />
        <Route path="/auth" component={Auth} />
        <PrivateRoute path="/application" component={Application} />
        <PublicRoute exact path="/" component={Public} />
        {/* Unknown URL: send people home instead of showing a blank page. */}
        <Redirect to="/" />
      </Switch>
    );
  }
};

Main.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default withRouter(connect(
  mapStateToProps,
  null
)(Main));
